import { Link } from "react-router-dom";

const steps = [
  {
    no: "01",
    icon: "ri-search-eye-line",
    title: "锁定原始信息",
    desc: "先找到最早出现的链接或视频，而不是只盯着被反复改写的转发版本。",
  },
  {
    no: "02",
    icon: "ri-time-line",
    title: "核对时间与场景",
    desc: "把画面中的日期、季节、地点与所述内容逐一对照，识别时间错位。",
  },
  {
    no: "03",
    icon: "ri-megaphone-line",
    title: "检索官方回应",
    desc: "找到主管部门或当事方的公开说明，重点看回应主体、事实与后续安排。",
  },
  {
    no: "04",
    icon: "ri-file-shield-2-line",
    title: "给出时间明确的结论",
    desc: "结论标注时间与来源，证据不足时如实标注“存疑”，并持续更新。",
  },
];

export default function VerifyProcess() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950 py-14 md:py-20">
      <div className="pointer-events-none absolute right-0 top-0 h-72 w-72 rounded-full bg-primary-500/20 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              <span className="h-[2px] w-6 bg-accent-500" aria-hidden="true" />
              How We Verify
            </div>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              我们一起把一条信息
              <br />
              核验清楚
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              核验不是替你做判断，而是把判断需要的事实按顺序摆在你面前。
              下面是我们处理每一起事件时遵循的四步流程，你也可以用同样的顺序检查任何一条爆料。
            </p>
            <Link
              to="/guide"
              className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              <span className="whitespace-nowrap">阅读求证指南</span>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {steps.map((step) => (
                <li
                  key={step.no}
                  className="rounded-lg border border-white/10 bg-white/[0.04] p-5 transition-colors hover:border-accent-500/50"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15 text-accent-400" aria-hidden="true">
                      <i className={`${step.icon} text-xl`} />
                    </span>
                    <span className="font-label text-2xl font-semibold text-white/20">{step.no}</span>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-bold text-background-50">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-300">{step.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}